import { useCallback, useEffect, useState } from 'react';
import { PageTitle } from '@library/components/PageTitle';
import { PromotionApprovalsList } from '@bo-components/promotions/approvals/PromotionApprovalsList';
import { Tab } from '@library/components/buttons';
import { useSearchParams } from 'react-router-dom';

type TabId = 'pending' | 'approved' | 'expired';

export const PromotionApprovalsDashboard = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<TabId>('pending');

  useEffect(() => {
    const statusParam = searchParams.get('status');
    if (statusParam === 'approved') {
      setActiveTab('approved');
    } else if (statusParam === 'expired') {
      setActiveTab('expired');
    } else {
      setActiveTab('pending');
    }
  }, [searchParams]);

  const isPendingTab = activeTab === 'pending';
  const isApprovedTab = activeTab === 'approved';
  const isExpiredTab = activeTab === 'expired';

  const handlePendingClick = useCallback(() => setActiveTab('pending'), []);
  const handleApprovedClick = useCallback(() => setActiveTab('approved'), []);
  const handleExpiredClick = useCallback(() => setActiveTab('expired'), []);

  return (
    <div className="flex w-auto flex-col gap-4 px-6 pb-2 pt-3">
      <div className="flex justify-between">
        <div>
          <PageTitle
            title="Promotion"
            className="text-soClean-180 text-sm !font-normal"
          />
          <span className="text-soClean-100 text-xl font-semibold">
            Approvals
          </span>
        </div>
        <div>
          <Tab
            active={isPendingTab}
            handleClick={handlePendingClick}
            id="pending"
            size="medium"
            tabName="Pending"
          />
          <Tab
            active={isApprovedTab}
            handleClick={handleApprovedClick}
            id="approved"
            size="medium"
            tabName="Approved"
          />
          <Tab
            active={isExpiredTab}
            handleClick={handleExpiredClick}
            id="expired"
            size="medium"
            tabName="Expired"
          />
        </div>
      </div>

      <PromotionApprovalsList listType={activeTab} />
    </div>
  );
};
